import type { ManifestIndex } from "utils/layout";
import FlexLayoutBuilder from "../../components/FlexLayoutBuilder.vue";
import FlexLayoutView from "../../components/FlexLayoutView.vue";
import TextBuilderVue from "../../components/TextBuilder.vue";
import TextViewVue from "../../components/TextView.vue";

export default {
  text: {
    label: "Text",
    view: TextViewVue,
    build: TextBuilderVue,
  },
  flex: {
    label: "Row or Column Layout",
    view: FlexLayoutView,
    build: FlexLayoutBuilder,
    defaults: {
      justify: "stretch",
      align: "stretch",
    },
  },
  // column_layout: {
  //   view
  // },
} as ManifestIndex;
